<div [(ngpTabsetValue)]="selectedTab" ngpTabset ngpTabsetOrientation="vertical">
  <div class="my-profile-tabs flex">
    <h4 class="typography-small-title font-bold">Profile</h4>
    <div ngpTabList>
      @for (tab of tabs; track tab.key) {
      <button
        ngpTabButton
        [ngpTabButtonValue]="tab.key"
        class="my-profile-tab button rounded-4 button--style-primary button--style-primary-bordered-2 h-38"
      >
        <svg-icon
          class="s-12 flex items-center justify-center"
          [src]="tab.icon"
        ></svg-icon>
        <span>{{ tab.label }}</span>
      </button>
      }
    </div>
  </div>
  <app-my-profile
    class="flex flex-col gap-16"
    ngpTabPanel
    ngpTabPanelValue="profile"
  ></app-my-profile>
  <app-user-games-history
    ngpTabPanel
    ngpTabPanelValue="games-history"
    class="flex flex-col gap-16"
    [user]="sessionService.profile()!"
    [active]="selectedTab() === 'games-history'"
  ></app-user-games-history>
  <app-user-transactions-history
    ngpTabPanel
    ngpTabPanelValue="transactions-history"
    class="flex flex-col gap-16"
    [user]="sessionService.profile()!"
    [active]="selectedTab() === 'transactions-history'"
  ></app-user-transactions-history>
  <app-user-self-exclusion
    ngpTabPanel
    ngpTabPanelValue="self-exclusion"
    [user]="sessionService.profile()!"
  ></app-user-self-exclusion>
</div>
